import GeneralError from '../../components/common/GeneralError';

const notFoundError = {
  title: 'ページが見つかりません',
  message:
    '申し訳ございませんが、アクセスいただいたURLはこのサーバーで見つかりませんでした。',
} as const;

/**
 * 画面が見つからないときの表示
 */
function NotFound() {
  return <GeneralError error={notFoundError} />;
}

export default NotFound;
